import Vue from 'vue'
import axios from 'axios'
import config from '@/../config'
import qs from 'qs'
import Cookies from 'js-cookie'

import config_api from './modules/config'
import banner from './modules/banner'
import analysis from './modules/analysis'
import auth from './modules/auth'
import site from './modules/site'
import fund from './modules/fund'
import real from './modules/real'
// import shop from './modules/shop'
import map from './modules/map'
import msg from './modules/msg'
import product from './modules/product'
import device from './modules/device'
import repair from './modules/repair'
import operator from './modules/operator'
import order from './modules/order'
import upload from './modules/upload'
import user from './modules/user'
import payment from './modules/payment'
import log from './modules/log'
import shorturl from './modules/shorturl'
import help from './modules/help'
import notice from './modules/notice'
import feedback from './modules/feedback'
import knowledge from './modules/knowledge'
import patrol from './modules/patrol'
import offices from './modules/offices'
import job from './modules/job'
import consumables from './modules/consumables'
import work from './modules/work'
import statistics from './modules/statistics'
import largeScreen from './modules/largeScreen'
import homePage from './modules/homePage'
import configure from './modules/configure'
import callcenter from './modules/callcenter'
import commondescr from './modules/commondescr'
import customer from './modules/customer'
import version from './modules/version'
import hospitalbackstage from './modules/hospitalbackstage'
import approvalprocess from './modules/approvalprocess'
import commodity from './modules/shop'
import label from './modules/label'
import backstageLog from './modules/backstageLog'
import logistics from './modules/logistics'
import ordersType from './modules/ordersType'
import ordercenter from './modules/ordercenter'
import shopping from './modules/shopping'
// 配置
axios.defaults.baseURL = config.API_HOST
// axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json'

// api 集合
const types = {}
Object.assign(
    types,
    config_api,
    payment,
    banner,
    analysis,
    shorturl,
    help,
    msg,
    fund,
    real,
    auth,
    site,
    operator,
    log,
    // shop,
    map,
    product,
    device,
    repair,
    order,
    upload,
    user,
    notice,
    feedback,
    knowledge,
    patrol,
    offices,
    job,
    consumables,
    configure,
    work,
    callcenter,
    statistics,
    largeScreen,
    homePage,
    commondescr,
    approvalprocess,
    customer,
    version,
    commodity,
    hospitalbackstage,
    label,
    backstageLog,
    logistics,
    ordersType,
    ordercenter,
    shopping
)

// 请求数据
function loadData(urlOrTypename = '', data = {}, method = 'get', config = {}, responseType = 'json') {

    // 合并配置
    let dconfig = { toast: false, toasterror: true, loading: false, loadingtext: 'Loading', login: true }
    config = Object.assign(dconfig, config)
    // 匹配api
    let url = ''
    let isBaseurl = true
    if (urlOrTypename.indexOf('http') >= 0) {
        url = urlOrTypename
        isBaseurl = false
    } else {
        if (types[urlOrTypename]) {
            url = types[urlOrTypename] + ''
        } else {
            url = urlOrTypename
        }
        isBaseurl = true
    }
    if (url !== 'undefined' && url !== null && url !== '') {
        // 设置PHPSESSID
        // data.PHPSESSID = Cookies.get('PHPSESSID') || ''
        // if (!data.PHPSESSID) {
        //     data.PHPSESSID = window.localStorage.getItem('PHPSESSID') || ''
        // }
        // axios配置
        let customerId = window.localStorage.getItem("customerId") ? window.localStorage.getItem("customerId") : 0
        if (customerId == "false") {
            customerId = 0
        }
        let con = {
            method: method.toUpperCase(),
            url: url,
            responseType: responseType,
            headers: {
                "AUTHORIZATION": global.$utils.data.get("", 'token') || '',
                "customerId": parseInt(customerId),
            },
        }
        // 去除基url
        if (isBaseurl === false) {
            con.baseURL = ''
        }
        // 拼装数据
        if (method.toLowerCase() === 'get') {
            con.params = data
        } else if (method.toLowerCase() === 'post') {
            // URLSearchParams
            con.data = data
        } else if (method.toLowerCase() === 'put') {
            // URLSearchParams
            con.data = data
        }
        // 异步处理
        return new Promise((resolve, reject) => {
            // loading
            if (config.loading === true) {
                $utils.loading.show(config.loadingtext)
            }
            axios
                .request(con)
                .then((response) => {
                    let result = response.data

                    // alert(urlOrTypename+JSON.stringify(result))
                    // 输出数据、下载文件
                    if (responseType == 'json') {
                        if (!result) {
                            result = {}
                        }
                        if (result && result.token) {
                            window.localStorage.setItem('token', result.token)
                        }
                    } else if (responseType == 'blob') {
                        if (config.loading === true) {
                            $utils.loading.hide()
                        }
                        // 判断是否返回code
                        let blob = new Blob([result])
                        if (result.type === 'application/json') {
                            let reader = new FileReader()
                            reader.onload = (e) => {
                                let xxres = {}
                                try {
                                    xxres = JSON.parse(e.target.result)
                                } catch (error) {
                                    resolve(result)
                                    return
                                }
                                if (xxres.code) {
                                    // go弹出提示
                                    if (xxres.code === 1) {
                                        // xx
                                        xxres.status = 1
                                    } else if (result.code == 401) {

                                        xxres.status = 0
                                        // 登录
                                        if (config.login === true) {
                                            window.localStorage.setItem('token', '')
                                            // $utils.toast.error("当前登录状态已过期，请重新登录！");
                                            $utils.url.push({ path: '/login' })
                                        }
                                    } else {
                                        xxres.status = 0
                                        // 提示
                                        if (config.toasterror === true) {
                                            $utils.toast.warn(xxres.msg)
                                        }
                                    }
                                    if (config.toast === true) {
                                        $utils.toast.text(xxres.msg)
                                    }
                                    if (config.loading === true) {
                                        $utils.loading.hide()
                                    }
                                    resolve(null)
                                    return
                                } else {
                                    //直接输出文件
                                    if (response.status == 200) {
                                        resolve(result)
                                    } else {
                                        resolve(null)
                                    }
                                }
                            }
                            return reader.readAsText(blob)
                        } else {
                            resolve(result)
                        }
                        return
                    } else {
                        // 判断是否返回code
                        if (result.code) {
                            // go弹出提示
                        } else {
                            //直接返回对应数据
                            if (response.status == 200) {
                                resolve(result)
                            } else {
                                resolve(null)
                            }
                        }
                    }
                    if (result.code === 200) {
                        // xx
                        result.status = 1
                    } else if (result.code == 401 || result.code == -2001 || result.code == -2098 || result.code == -2099) {

                        result.status = 0
                        // 登录
                        if (config.login === true) {
                            window.localStorage.setItem('token', '')
                            $utils.toast.error("当前登录状态已过期，请重新登录！");
                            $utils.url.push({ path: '/login' })
                        }
                    } else {
                        result.status = 0
                        // 提示
                        if (config.toasterror === true) {
                            let toastdesc = ''
                            if (result && result.msg) {
                                if (result.msg.length > 18) {
                                    toastdesc = result.msg || ''
                                }
                            }
                            $utils.toast.warn(result.msg, toastdesc)
                        }
                    }
                    if (config.toast === true) {
                        let toastdesc = ''
                        if (result && result.msg) {
                            if (result.msg.length > 18) {
                                toastdesc = result.msg || ''
                            }
                        }
                        $utils.toast.text(result.msg, toastdesc)
                    }
                    if (config.loading === true) {
                        $utils.loading.hide()
                    }
                    resolve(result)
                })
                .catch((error) => {
                    console.log('api error', error)
                    if (config.loading === true) {
                        $utils.loading.hide()
                    }
                    if (config.toasterror === true) {
                        $utils.toast.error('请求错误' + error.message)
                    }
                    reject(new Error(null))
                })
        })
    } else {
        $utils.loading.hide()
        return new Promise((resolve, reject) => {
            if (config.toasterror === true) {
                $utils.toast.warn('Url请求错误')
            }
            resolve(null)
            // reject(null)
        })
    }
}

let api = {
    load: loadData,
}
Vue.prototype.$axios = axios

export default api
